.root {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
